import {decorate, inject, injectable} from '@yosmanyga/di';
import {action, observable, runInAction, makeObservable} from 'mobx';
import {Dispatcher} from '@yosmanyga/base';
import {NotesApi} from '../../data';

class PlayInputNotePromptController {
    executing: boolean;
    note: string | null;

    constructor(
        private dispatcher: Dispatcher,
        private noteApi: NotesApi
    ) {
        this.executing = false;
        this.note = null;

        this.dispatcher.register(
            'play_board_output_selected',
            this.listenToBoardOutputSelected
        );

        makeObservable(this, {
            executing: observable,
            note: observable,
            execute: action,
            cancel: action,
            listenToBoardOutputSelected: action,
        });
    }

    execute = async () => {
        if (!this.note) {
            throw Error('LogicException');
        }

        const note = this.note;

        runInAction(() => {
            this.executing = true;
            this.note = null;
        });

        this.noteApi.addNote(note).then();

        this.dispatcher.retrieve<() => void>('play_input_note_done').map(service => service())

        runInAction(() => {
            this.executing = false;
        });
    };

    cancel = () => {
        this.dispatcher.retrieve<() => void>('play_input_note_done').map(service => service())

        this.note = null;
    };

    listenToBoardOutputSelected = (value: string) => {
        this.note = value;
    };
}

decorate(injectable(), PlayInputNotePromptController);
decorate(inject(Dispatcher), PlayInputNotePromptController, 0);
decorate(inject(NotesApi), PlayInputNotePromptController, 1);

export {PlayInputNotePromptController};
